import { css } from 'lit';

export const newInstancePageStyles = css`
  form {
    max-width: var(--form-width-md);
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2);
    padding-top: var(--space-3);
    border-top: var(--border-width) solid var(--border);
  }
`;
